export default __webpack_public_path__ + "static/media/hailscale-logo-color.c6ce2353.svg";